import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AddIcon from '@material-ui/icons/Add';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import Fab from '@material-ui/core/Fab';
import _ from 'lodash';

import { CONFIRM_DIALOG, QUALITY_CONTROL_QUESTION_DIALOG } from '../../../../redux/constants/dialogs';
import Grid from '../../../Common/Grid';
import getNoDataCellComponent from '../../../Common/NoDataCellComponent';

import styles from './styles';

const QUESTION_TYPES = [
  {
    code: 'YN',
    name: 'Yes/No',
    description: 'Request user to confirm a specified action',
  }, {
    code: 'PH',
    name: 'Upload Image',
    description: 'Request user to upload image as evidence',
  },
];

const getType = (code) => {
  return QUESTION_TYPES.find((type) => type.code === code);
};

const getTypeName = (code) => {
  return getType(code) ? getType(code).name : 'Unknown';
};

const COLUMNS = [
  { name: 'question', title: 'Question' },
  { name: 'type', title: 'Type' },
  { name: 'mandatory', title: 'Mandatory' },
];

const COLUMN_EXTENSIONS = [
  // { columnName: 'from', width: 120 },
  // { columnName: 'to', width: 120 },
  // { columnName: 'action', width: 80 },
];

const getCellComponent = ({ row, column, value }) => {
  switch (column.name) {
    case 'type':
      return value ? getTypeName(value) : null;
    case 'mandatory':
      return value ? 'Yes' : 'No';
    default:
      return value;
  }

};

class QuestionsGrid extends Component {
  handleSave = (question) => {
    console.log('handleSave', question);
    if (!question) {
      return;
    }

    let found = false;
    const questions = this.props.questions.map((q) => {
      if (question.id === q.id) {
        found = true;
        return question;
      }

      return q;
    });

    if (!found) {
      questions.push(question);
    }

    this.props.onChange(questions);
  };

  handleAdd = () => {
    this.handleEdit({});
  };

  handleEdit = (question) => {
    this.props.showDialog(QUALITY_CONTROL_QUESTION_DIALOG, { question, onSave: this.handleSave });
  };

  handleRemove = (question) => {
    return new Promise((resolve, reject) => {
      const context = {
        type: 'warning',
        title: 'Remove QA Question?',
        message: 'Are you sure you wish to remove this question?',
        onConfirm: () => {
          this.props.onChange(this.props.questions.filter((r) => r.id !== question.id));
          this.props.hideDialog(CONFIRM_DIALOG);
          resolve();
        },
        onReject: reject,
      };

      this.props.showDialog(CONFIRM_DIALOG, context);
    });
  };

  render() {
    const { questions } = this.props;

    const buttons = [<Fab
      key="add"
      size="small"
      style={styles.addQuestion}
      onClick={this.handleAdd} color="secondary">
      <AddIcon/>
    </Fab>];

    return (<Grid
      buttons={buttons}
      columns={COLUMNS}
      columnExtensions={COLUMN_EXTENSIONS}
      cellComponent={getCellComponent}
      fetch={_.noop}
      data={{ data: questions }}
      onEdit={this.handleEdit}
      onRemove={this.handleRemove}
      noDataCellComponent={getNoDataCellComponent(<PlaylistAddCheckIcon style={styles.noQuestions}/>, 'QA Questions')}
    />);
  }
}

QuestionsGrid.propTypes = {
  questions: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

export default QuestionsGrid;

// function mapStateToProps(state) {
//   return {
//     // jobProfile: state.get('jobprofiles').get('jobProfile').toJS(),
//     // initialValues: state.get('jobprofiles').get('jobProfile').toJS(),
//     isDialogVisible: isDialogVisibleSelector(state),
//   };
// }
//
// function mapDispatchToProps(dispatch) {
//   return bindActionCreators({
//     showDialog,
//     hideDialog,
//   }, dispatch);
// }
//
// export default connect(mapStateToProps, mapDispatchToProps)(QuestionsGrid);



// WEBPACK FOOTER //
// ./src/components/Admin/JobProfiles/QuestionsGrid/index.js